import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Copy } from "@phosphor-icons/react";
import { fmtCurrency } from "@/lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BillingCard() {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/billing/summary`)
      .then(({ data }) => {
        if (active) setSummary(data);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!summary) return null;

  const link = `${window.location.origin}/quick-breakdown?ref=${summary.ref_code}`;
  const cycleLabel = new Date(summary.cycle_start).toLocaleDateString("en-CA", {
    month: "long",
    year: "numeric",
  });

  const copyLink = async () => {
    await navigator.clipboard.writeText(link);
    toast.success("Public link copied", { description: "Leads from this link are attributed to you." });
  };

  return (
    <div
      data-testid="billing-summary"
      className="mb-8 bg-white border border-brand-line rounded-md p-6"
    >
      <div className="grid sm:grid-cols-3 gap-6">
        <div>
          <div className="text-[10px] uppercase tracking-[0.16em] text-brand-muted">
            Leads this cycle · {cycleLabel}
          </div>
          <div data-testid="billing-lead-count" className="mt-1 font-serif text-3xl text-brand-forest">
            {summary.lead_count}
          </div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.16em] text-brand-muted">Your rate</div>
          <div data-testid="billing-rate" className="mt-1 font-serif text-3xl text-brand-forest">
            {fmtCurrency(summary.per_lead_rate)}
            <span className="text-sm text-brand-muted font-sans"> / qualified lead</span>
          </div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-[0.16em] text-brand-muted">
            Current cycle charge
          </div>
          <div data-testid="billing-current-charge" className="mt-1 font-serif text-3xl text-brand-copper">
            {fmtCurrency(summary.current_charge)}
          </div>
        </div>
      </div>
      <div className="mt-5 pt-4 border-t border-brand-line flex flex-wrap items-center gap-2 text-xs text-brand-ink/70">
        <span className="text-brand-muted">Your public capture link:</span>
        <code data-testid="billing-ref-link" className="px-2 py-1 rounded bg-brand-cream text-brand-forest font-semibold break-all">
          {link}
        </code>
        <button
          onClick={copyLink}
          data-testid="btn-copy-ref-link"
          className="inline-flex items-center gap-1 text-brand-copper hover:text-brand-forest font-semibold transition-colors"
        >
          <Copy size={13} weight="bold" /> Copy
        </button>
      </div>
    </div>
  );
}
